var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSeatThin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 21,
  fill: "none",
  viewBox: "0 0 20 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeMiterlimit: 10,
  d: "M13.529 11.725h-4.09L7.963 3.99a1.52 1.52 0 0 0-.651-.938 1.504 1.504 0 0 0-2.066.41 1.53 1.53 0 0 0-.25 1.116l1.705 8.96c.068.348.254.662.525.887.272.225.613.349.965.349h5.339c.4 0 .786-.16 1.07-.447a1.53 1.53 0 0 0 0-2.155 1.5 1.5 0 0 0-1.07-.446Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m9.78 11.713.534-1.736s.134-.208.312-.312.546-.105.546-.105h2.58M7.5 17.79h5.937c.938 0 0-1.563 0-1.563l-.814-1.454"
})));
export { SvgSeatThin as ReactComponent };